import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { LabelForm } from "components/label";
import { Controller, useController } from "react-hook-form";
import { Error } from "components/error";
import { withErrorBoundary } from "react-error-boundary";
import { ErrorComponent } from "components/common";
const DropdownSearch = ({
	data,
	label,
	placeholder = "",
	control,
	name,
	error,
	setValueData,
	...rest
}) => {
	return (
		<div className="form-group pms-select-wrap">
			<LabelForm>{label}</LabelForm>
			<div className="pms-select-search">
				<Controller
					control={control}
					name={name}
					render={({ field: { onChange, value } }) => {
						return (
							<Autocomplete
								{...rest}
								onChange={(event, value) => onChange(value)}
								sx={{
									display: "inline-block",
									width: "100%",
								}}
								noOptionsText={"Không tìm thấy"}
								options={data}
								value={value || ""}
								isOptionEqualToValue={(option, value) =>
									option.value === value.value
								}
								renderInput={params => (
									<div
										ref={params.InputProps.ref}
										className="relative">
										<input
											type="text"
											name={name}
											placeholder={
												placeholder
													? placeholder
													: label
											}
											{...params.inputProps}
										/>
										<i className="fa-solid fa-caret-down text-sm absolute right-0 top-1/2 -translate-y-1/2"></i>
									</div>
								)}
							/>
						);
					}}
				/>
			</div>
			{error && <Error>{error[name]?.message}</Error>}
		</div>
	);
};

export default withErrorBoundary(DropdownSearch, {
	FallbackComponent: ErrorComponent,
});
